<template>
  <el-dialog
    title="处理设备报警信息"
    :visible.sync="dialogTableVisible"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    width="500px"
  >
    <div class="content">
      <div class="first">
        <span v-if="status == 1">处理意见：</span>
        <span v-if="status == 2">误报意见：</span>
        <el-input
          class="input"
          v-model.trim="desc"
          type="textarea"
          :placeholder="status == 1 ? '请输入处理意见' : '请输入误报意见'"
          size="mini"
        ></el-input>
      </div>
      <div class="bottom">
        <el-button type="primary" plain size="mini" @click="handle"
          >确定</el-button
        >
        <el-button plain size="mini" @click="handleClose">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ProtectDeviceManagementInfoHandle",
  props: {
    handleResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    status: {
      type: Number,
      default: {
        return: 0
      }
    },
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      desc: ""
    };
  },
  created() {},
  mounted() {},
  watch: {
    handleResize: function(newVal, oldVal) {
      if (newVal) {
        this.dialogTableVisible = true;
      }
    }
  },
  computed: {},
  methods: {
    handleClose() {
      this.desc = "";
      this.dialogTableVisible = false;
    },
    async handle() {
      if (this.desc == "") {
        if (this.status == 1) {
          this.$message("请输入处理意见！");
        } else {
          this.$message("请输入误报意见！");
        }
        return;
      }
      let req = {
        alarmId: this.info.eventId,
        desc: this.desc,
        status: this.status,
        handler: this.$store.getters.getUserInfo.userName
      };
      let res = await this.$Http.handleSafeEquipmentAlert(req);
      if (res.code == 200) {
        this.handleClose();
        this.$emit("getList");
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: 30px;
  .first {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .input {
    width: 300px;
  }
  .bottom {
    padding: 20px 70px;
  }
}
</style>
